import { fakeCall, saveUser } from './utilities'

// mock JSON data is coomented in env.development file make sure to uncomment it before using it
export const fetchUserByOpportunityId = (opportunityId) =>
  fakeCall(process.env.REACT_APP_Mock_CustomerJSON)

export const fetchOpportunityInfo = (opportunityId) =>
  fakeCall(process.env.REACT_APP_Mock_OpportunityJSON)

export const fetchIndividualEstimate = (opportunityId, estimateId) =>
  fakeCall(process.env.REACT_APP_Mock_IndividualEstimateJSON)

export const fetchEstimates = (opportunityId) => fakeCall(process.env.REACT_APP_Mock_EstimatesJSON)

export const validateAccessCode = (opportunityId, accessCode) => {
  const mockResult =
    accessCode === '111111'
      ? {
          token: 'JWT_token_here',
          opportunityId: 'fake',
          expiresIn: '60',
        }
      : accessCode === '222222'
      ? Promise.reject(`Access code ${accessCode} is expired`)
      : Promise.reject(`Access code ${accessCode} is invalid`)

  return fakeCall(mockResult, () => saveUser(mockResult))
}

export const requestAccessCode = (opportunityId, authenticationMethod) => {
  const mockResult = {
    status: 'success',
  }
  return fakeCall(mockResult)
}
